// Teminat mektubu türü (zorunlu): Kesin Mektup / Geçici Mektup
export const LETTER_KINDS = [["kesin", "Kesin Mektup"], ["gecici", "Geçici Mektup"]];
export const letterKindLabel = (v) => LETTER_KINDS.find(([k]) => k === v)?.[1] || "";
export const letterKindCls = (v) => (v === "kesin" ? "bg-emerald-100 text-emerald-800" : v === "gecici" ? "bg-sky-100 text-sky-800" : "bg-slate-100 text-slate-500");
// bankadan iade alınan mektup: iade tarihi dolu → Limit Risk'e ve vade uyarılarına girmez
export const isReturned = (d) => !!(d?.return_date || "").trim();
export const RETURN_ACCEPT = "image/jpeg,image/png,image/webp,application/pdf,.jpg,.jpeg,.png,.webp,.pdf";
